import {all, call, put, takeEvery} from 'redux-saga/effects';
import {
  MenusActionTypes, deleteError, deleteSuccess, fetchError, fetchSuccess, createError, createSuccess,
  updateSuccess, updateError, fetchItemSuccess, fetchItemError
} from '@actions/menu';
import menuApi from '@api/menu';
import {ReduxAction} from "@actions/index";


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(menuApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err))
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(menuApi.delete, payload);
    yield put(deleteSuccess(payload.params));
  } catch (err) {
    yield put(deleteError(err))
  }
}


function* handleCreate({payload}: ReduxAction) {
  try {
    const {data} = yield call(menuApi.create, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(createSuccess(data))
  } catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(menuApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(data));
  } catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleFetchItem({payload}: ReduxAction) {
  try {
    const {data} = yield call(menuApi.getItem, payload);
    yield put(fetchItemSuccess(data))
  } catch (err) {
    yield put(fetchItemError(err))
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* menusSaga() {
  yield all([
    yield takeEvery(MenusActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(MenusActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(MenusActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(MenusActionTypes.UPDATE_REQUEST, handleUpdate),
    yield takeEvery(MenusActionTypes.FETCH_ITEM_REQUEST, handleFetchItem),
  ])
}

export default menusSaga;
